import { buildImage, CampaignMonitorRoute, RouteSlotInput } from '@luks/ui';
import { graphql, useStaticQuery } from 'gatsby';

import { SettingsNewsletterFormQuery } from '../../../generated/types/gatsby';

export const mapCampaignMonitorForm = (
  input: CmSubscribeFormFragment | null,
): RouteSlotInput<typeof CampaignMonitorRoute, 'body', 'SubscribeFormCM'> => {
  return {
    key: 'SubscribeFormCM',
    input: function useCampaignMonitorForm() {
      const settings = useStaticQuery<SettingsNewsletterFormQuery>(graphql`
        query SettingsNewsletterForm {
          allDrupalSettingsNewsletterForm {
            nodes {
              imageForm {
                original
              }
            }
          }
        }
      `);
      const image =
        settings.allDrupalSettingsNewsletterForm.nodes[0]?.imageForm?.original;
      return [
        {
          title: input?.title,
          Image: buildImage({
            src: image || '/luks-doctor.jpeg',
            width: 100,
            height: 100,
          }),
        },
        200,
      ];
    },
  };
};
